import { MouseEvent, MouseEventHandler, useCallback, useRef } from "react";

interface ITapTrackerProps {
  children: React.ReactNode;
  onTap: (clicks: number) => void;
}

type EmptyCallback = () => void;

type CallbackFunction<Target = Element> = MouseEventHandler<Target> | EmptyCallback;

const DEFAULT_THRESHOLD = 500;

export const TapTracker = (props: ITapTrackerProps) => {
  const { children, onTap } = props;
  const timer = useRef<NodeJS.Timeout | null>(null);
  const clickCount = useRef<number>(0);

  const handler = useCallback<CallbackFunction<Element>>(
    (event: MouseEvent<Element>) => {
      clickCount.current += 1;

      if (!timer.current) {
        timer.current = setTimeout(() => {
          onTap(clickCount.current);
          timer.current = null;
          clickCount.current = 0;
        }, DEFAULT_THRESHOLD);
      }
    },
    [onTap]
  );

  return (
    <div className="TapTracker" onClick={handler}>
      { children }
    </div>
  );
};
